import { HOME_PROJECT_ID } from '@/lib/appConstants.js';

export const SCHEDULE_BUILDER_COMPOSER_DRAFT_CONTEXT_KEY = 'schedule-builder:new';
export const TRIGGER_BUILDER_COMPOSER_DRAFT_CONTEXT_KEY = 'trigger-builder:new';
export const WORKFLOW_BUILDER_COMPOSER_DRAFT_CONTEXT_KEY = 'workflow-builder:new';

const normalizeProjectId = (projectId) => {
  const normalizedProjectId = String(projectId || '')
    .trim()
    .toLowerCase();

  return normalizedProjectId || HOME_PROJECT_ID;
};

export const buildNewThreadComposerDraftContext = ({ projectId } = {}) => {
  const normalizedProjectId = normalizeProjectId(projectId);

  return {
    kind: 'new-thread',
    projectId: normalizedProjectId,
    contextKey: `new-thread:project:${normalizedProjectId}`
  };
};

export const buildThreadComposerDraftContext = ({ threadId } = {}) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return null;
  }

  return {
    kind: 'thread',
    threadId: normalizedThreadId,
    contextKey: `thread:${normalizedThreadId}`
  };
};

export const buildWorkflowBuilderComposerDraftContext = () => {
  return {
    kind: 'workflow-builder',
    contextKey: WORKFLOW_BUILDER_COMPOSER_DRAFT_CONTEXT_KEY
  };
};

export const buildScheduleBuilderComposerDraftContext = () => {
  return {
    kind: 'schedule-builder',
    contextKey: SCHEDULE_BUILDER_COMPOSER_DRAFT_CONTEXT_KEY
  };
};

export const buildTriggerBuilderComposerDraftContext = () => {
  return {
    kind: 'trigger-builder',
    contextKey: TRIGGER_BUILDER_COMPOSER_DRAFT_CONTEXT_KEY
  };
};

/* The compact composer opened over one workflow step has its own scope, so its draft and
   attachments never mix with the page launcher. */
export const WORKFLOW_STEP_ASK_COMPOSER_DRAFT_CONTEXT_KEY_PREFIX = 'workflow-step-ask:';

export const buildSurfaceComposerDraftContext = ({ surfaceMode = '' } = {}) => {
  const normalizedSurfaceMode = String(surfaceMode || '')
    .trim()
    .toLowerCase();

  if (normalizedSurfaceMode === 'workflow') {
    return buildWorkflowBuilderComposerDraftContext();
  }

  if (normalizedSurfaceMode === 'schedule') {
    return buildScheduleBuilderComposerDraftContext();
  }

  if (normalizedSurfaceMode === 'trigger') {
    return buildTriggerBuilderComposerDraftContext();
  }

  return null;
};

export const resolveComposerDraftContext = ({ draftContext = null, threadId = null, surfaceMode = '' } = {}) => {
  if (draftContext?.contextKey) {
    return draftContext;
  }

  const threadDraftContext = buildThreadComposerDraftContext({
    threadId
  });

  if (threadDraftContext?.contextKey) {
    return threadDraftContext;
  }

  return buildSurfaceComposerDraftContext({
    surfaceMode
  });
};
